import { Box } from "components/ui";
import React from "react";
import { ActivityIndicator, Platform } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Container from "./Container";
import ScrollContainer from "./ScrollContainer";

interface PageLoaderProps {
	size?: "default" | "sm";
}
const PageLoader = ({ size }: PageLoaderProps) => {
	let isMobile = useIsMobile();
	if (isMobile && Platform.OS !== "web") {
		return (
			<Box minHeight={size === "sm" ? 20 : 300} marginTop={size === "sm" ? 25 : 50}>
				<ActivityIndicator size={size === "sm" ? "small" : "large"} color={"#1A428A"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} />
			</Box>
		);
	}
	return (
		<ScrollContainer withFooter={false} withPadding={false}>
			{/* <Container> */}
			<ActivityIndicator size={size === "sm" ? "small" : "large"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />
			{/* </Container> */}
		</ScrollContainer>
	);
};

export default PageLoader;
